import { create } from 'zustand';
import { api } from './api.js';

let autosaveTimer = null;

export const useStore = create((set, get) => ({
  token: null,
  loading: true,
  pkg: null,
  data: {},
  owners: [],
  documents: [],
  errors: {},
  saving: false,
  lastSaved: null,

  load: async (token) => {
    set({ token, loading: true });
    try {
      const res = await api.getPackage(token);
      set({
        pkg: res.package,
        data: res.data || {},
        owners: res.owners || [],
        documents: res.documents || [],
        loading: false,
      });
    } catch (err) {
      set({ loading: false, loadError: err });
    }
  },

  setField: (key, value) => {
    set((s) => ({ data: { ...s.data, [key]: value } }));
    if (autosaveTimer) clearTimeout(autosaveTimer);
    autosaveTimer = setTimeout(() => get().flushSave(), 800);
  },

  flushSave: async () => {
    const { token, data } = get();
    if (!token) return;
    set({ saving: true });
    try {
      await api.saveFields(token, data);
      set({ saving: false, lastSaved: new Date() });
    } catch (err) {
      set({ saving: false, saveError: err });
    }
  },

  addOwner: async (owner) => {
    const { token } = get();
    const created = await api.addOwner(token, owner);
    const res = await api.getPackage(token);
    set({ owners: res.owners });
    return created;
  },

  updateOwner: async (id, owner) => {
    const { token } = get();
    await api.updateOwner(token, id, owner);
    const res = await api.getPackage(token);
    set({ owners: res.owners });
  },

  removeOwner: async (id) => {
    const { token } = get();
    await api.removeOwner(token, id);
    set((s) => ({ owners: s.owners.filter((o) => o.id !== id) }));
  },

  uploadDocuments: async (category, files) => {
    const { token } = get();
    const res = await api.uploadDocs(token, category, files);
    set((s) => ({ documents: [...res.uploaded, ...s.documents] }));
    return res.uploaded;
  },

  removeDocument: async (id) => {
    const { token } = get();
    await api.removeDoc(token, id);
    set((s) => ({ documents: s.documents.filter((d) => d.id !== id) }));
  },
}));
